{
  "cancel": {},
  "fail": {
    "back": {},
    "cancel": {},
    "tryAgain": {}
  },
  "full": {},
  "grant": {},
  "permissionName": {},
  "permissionType": {},
  "read": {},
  "report": {},
  "run": {},
  "success": {
    "close": {}
  },
  "write": {}
}
